module.exports = __webpack_public_path__ + "distribution/img/ico1.630b052a.png";